var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Popup',{attrs:{"show":_vm.showPopup,"title":"Bedoelde u misschien één van volgende projecten?","saving":_vm.saving,"height":800,"width":1200},on:{"hide":_vm.hide,"save":_vm.save},scopedSlots:_vm._u([{key:"body",fn:function(){return [_c('Datagrid',{ref:"grid",attrs:{"name":'projectsTable',"columns":_vm.columns,"datasource":_vm.matchingProjects,"onCellClick":_vm.cellclick,"medium":true}})]},proxy:true},{key:"bottom-toolbar",fn:function(){return [_c('dx-toolbar-item',{attrs:{"widget":"dxButton","toolbar":"bottom","location":"after","options":{
        text: _vm.$t('buttons.Cancel'),
        onClick: _vm.hide,
        type: 'default',
        tabindex: 0,
      }}}),_c('dx-toolbar-item',{attrs:{"widget":"dxButton","toolbar":"bottom","location":"after","options":{
        text: 'Nieuw project aanmaken',
        onClick: _vm.save,
        stylingMode: 'outlined',
        type: 'default',
        tabindex: 1,
        disabled: _vm.saving
      }}})]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }